import {type MfaOption} from 'types/Mfa'

///////////////////////////////////////////////////////////////////////////////

export enum VisibleRoles {
  ORGANISATION_ADMIN = 'organisation_admin',
  ACCOUNT_ADMIN = 'account_admin',
  READ_ONLY = 'read_only',
}

export type Role = {
  role_uuid: string
  role_name: string
  organisation_uuid?: string
  account_uuid?: string
}

export type IdentityRole = {
  organisation_uuid?: string
  account_uuid?: string
  role: Role
}

export type User = {
  uuid: string
  username: string
  email: string
  enabled: boolean
  organisation_uuid: string
  first_name: string
  last_name: string
  locale: string
  timezone: string
  salutation?: string
  created: number
  phone_number: string
  country_code: string
  auth_phone_number: string
  auth_phone_number_country_prefix: string
  two_factor_auth_choice: MfaOption
  two_factor_auth_choice_raw?: MfaOption
  last_login: number
  status: UserStatus
  roles?: Role[]
  invitation_expires_at: string
  identity_roles?: IdentityRole[]
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
  INVITE_EXPIRED = 'invite_expired',
}
